import { get } from "lodash";

const deceasedLabel = (deceased?: { value?: string; unit?: string }) => {
  const age = deceased?.value;
  if (!age) {
    return "";
  }

  if (age === "0") {
    return " (deceased)";
  }

  const unit = (deceased.unit || "years").toLowerCase();
  return ` (deceased [${age} ${unit}])`;
};

export const renderFamilyHistoryEntry = (familyHistory) => {
  const parts = [];
  const conditions = get(familyHistory, "condition.text");
  if (conditions) {
    parts.push(conditions);
  }

  const relationships = get(familyHistory, "relationships");
  if (relationships?.length > 0) {
    const relNames = relationships.map((r) => {
      let relText =
        r.relationship && r.relationship.text
          ? r.relationship.text
          : get(r, "relationship.coding[0].display");

      relText = `${relText}${deceasedLabel(r.deceased)}`;

      if (
        r.onset &&
        r.onset.value &&
        r.onset.unit &&
        r.onset.code &&
        r.onset.system
      ) {
        relText = `${relText} - ${r.onset.value} ${r.onset.unit}`;
      }
      if (r.contributedToDeath) {
        relText = `${relText} (contributed to death)`;
      }

      return relText;
    });
    parts.push(relNames.join(" · "));
  }

  return <>{`⚬ ${parts.join(" · ")}`}</>;
};
